<div class="container-fluid p-0">
    <table class="table table-hover">
        <thead>
        <tr>
            <th class="feature feature-name">
                <b>Key</b>
            </th>
            <th *ngFor="let role of roles">
                <div class="role-name">
                    {{role.name}}
                </div>
            </th>
            <th class="after">

            </th>
        </tr>
        </thead>
        <tr *ngFor="let featureHasRole of featureHasRoleMatrix">
            <th class="feature feature-side">
                {{featureHasRole.feature.key}}
            </th>
            <td (contextmenu)="setUserFieldForFeature($event, featureHasRole, role)"
                *ngFor="let role of roles"
                title="{{role.name}}"
                class="checkox-td">
                <mat-checkbox
                    (change)="checkFeature($event, featureHasRole.feature, role)"
                    [checked]="featureHasRole.hasRoles.has(role.key)"
                    [disabled]="disabled">
                    <span *ngIf="featureHasRole.hasRoles.has(role.key)">
                        {{featureHasRole.hasRoles.get(role.key).user_field}}
                    </span>
                </mat-checkbox>
            </td>
            <th class="after">

            </th>
        </tr>
    </table>
</div>
